import { DeleteIcon } from "@chakra-ui/icons";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";

import { AccessRule } from "@/api";
import { useStatusQuery } from "@/queries/query-status";

import { useDeleteUser } from "../api/delete-user";

export const UserDeleteButton = ({ user }: { user: AccessRule }) => {
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const { mutate } = useDeleteUser();
  const statusResponse = useStatusQuery();

  const isAdmin = statusResponse.data?.authenticated && statusResponse.data?.hasAdminAccess;

  if (!isAdmin) return null;

  return (
    <>
      <Modal isCentered isOpen={confirmModalOpen} onClose={() => setConfirmModalOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Weet je het zeker?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Weet je zeker dat je de gebruiker <Text as="strong">{user.email}</Text> wilt
            verwijderen?
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={() => setConfirmModalOpen(false)}>
              Annuleren
            </Button>
            <Button
              colorScheme="red"
              onClick={() => {
                mutate(user.id);
                setConfirmModalOpen(false);
              }}
            >
              Verwijder
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Button onClick={() => setConfirmModalOpen(true)} minW={0} p={0} h={8} w={8} variant="danger">
        <DeleteIcon m={0} h={4} w={4} />
      </Button>
    </>
  );
};
